<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">C<span class="small">ONTENTS</span></p>
<p class="toc1"><span href="#/chapter01" title="Link target outside of Sample">Lighting the Spirit</span></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">1</span></p>
<p class="toc1"><span href="#/chapter03" title="Link target outside of Sample">From the Cabin’s Porch, Overlooking the Edisto River, April</span></p>
<p class="toc1"><span href="#/chapter04" title="Link target outside of Sample">Woman at the Window</span></p>
<p class="toc1"><span href="#/chapter05" title="Link target outside of Sample">How It Can Happen</span></p>
<p class="toc1"><span href="#/chapter06" title="Link target outside of Sample">Mythologies</span></p>
<p class="toc1"><span href="#/chapter07" title="Link target outside of Sample">Remote Viewing</span></p>
<p class="toc1"><span href="#/chapter08" title="Link target outside of Sample">At Night When the Music Comes</span></p>
<p class="toc1"><span href="#/chapter09" title="Link target outside of Sample">Closing In</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">2</span></p>
<p class="toc1"><span href="#/chapter11" title="Link target outside of Sample">From the Window, the Marina</span></p>
<p class="toc1"><span href="#/chapter12" title="Link target outside of Sample">Darker Than Before</span></p>
<p class="toc1"><span href="#/chapter13" title="Link target outside of Sample">Always Paris</span></p>
<p class="toc1"><span href="#/chapter14" title="Link target outside of Sample">Ghost Animals</span></p>
<p class="toc1"><span href="#/chapter15" title="Link target outside of Sample">I Want to Say Something</span></p>
<p class="toc1"><span href="#/chapter16" title="Link target outside of Sample">I Am Trying to Tell You Something</span></p>
<p class="toc1"><span href="#/chapter17" title="Link target outside of Sample">In the Country of Birds and Wild Animals</span></p>
<p class="toc1"><span href="#/chapter18" title="Link target outside of Sample">Moving Toward the Margins</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">3</span></p>
<p class="toc1"><span href="#/chapter20" title="Link target outside of Sample">Goethe at the Window of His Room in Rome</span></p>
<p class="toc1"><span href="#/chapter21" title="Link target outside of Sample">We Learn How the Brain Can Be Tricked</span></p>
<p class="toc1"><span href="#/chapter22" title="Link target outside of Sample">After Your Death</span></p>
<p class="toc1"><span href="#/chapter23" title="Link target outside of Sample">Geel</span></p>
<p class="toc1"><span href="#/chapter24" title="Link target outside of Sample">Nudes</span></p>
<p class="toc1"><span href="#/chapter25" title="Link target outside of Sample">What Can I Possibly Complain Of</span></p>
<p class="toc1"><span href="#/chapter26" title="Link target outside of Sample">Grace</span></p>
<p class="toc1"><span href="#/chapter27" title="Link target outside of Sample">Reviewing the Latest Book of a Poet Whose Work I Once Loved</span></p>
<p class="toc"><span href="#/chapter28" title="Link target outside of Sample">4</span></p>
<p class="toc1"><span href="#/chapter29" title="Link target outside of Sample">The Unattainable</span></p>
<p class="toc1"><span href="#/chapter30" title="Link target outside of Sample">Interior with Woman Sewing, 1820s,</span></p>
<p class="toc1"><span href="#/chapter31" title="Link target outside of Sample">Nightshirt Sonata</span></p>
<p class="toc1"><span href="#/chapter32" title="Link target outside of Sample">The Little Boat Slips Out to Sea</span></p>
<p class="toc1"><span href="#/chapter33" title="Link target outside of Sample">Too Late</span></p>
<p class="toc1"><span href="#/chapter34" title="Link target outside of Sample">Your Death Did Not Sneak Up</span></p>
<p class="toc1"><span href="#/chapter35" title="Link target outside of Sample">The Seven Villages</span></p>
<p class="toc1"><span href="#/chapter36" title="Link target outside of Sample">A Christmas of Cockatiels</span></p>
<p class="toc1"><span href="#/chapter37" title="Link target outside of Sample">You Could Be Drinking Faulkner’s Bourbon</span></p>
<p class="toc1"><span href="#/chapter38" title="Link target outside of Sample">Begin with Water Crystals</span></p>
<p class="toc1"><span href="#/chapter39" title="Link target outside of Sample">Prism</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?b34e3632